###
Initialize the Grassdoor cart
###
import * as cart from 'library/store/grassdoor-cart'
import { loadScript, nonEmpty } from 'library/services/helpers'
import { loadGrassdoorAnalaytics } from '../services/grassdoor-analytics'
export default ({ $config, $axios, app, store }, inject) ->

	# Make vuex module
	store.registerModule 'cart', {
		namespaced: true
		...cart
	}

	# Load SDK and initialize cart
	initializeSdk = (zip) ->

		# Load analytics script (has to happen first)
		analytics = loadGrassdoorAnalaytics($config.grassdoor.segmentKey)
		app.router.afterEach (to) -> window.analytics?.page()

		# Load SDK
		await loadScript 'https://cartwidget.grassdoor.com/grassdoorPlugin.js'

		# Initialize SDK
		await grassdoorCart.initialize
			id: 'grassdoor-widget'
			x_api_key: $config.grassdoor.apiKey
			url: $config.grassdoor.endpoint
			checkoutUrl: $config.grassdoor.checkoutUrl
			BRANCH_IO_KEY: $config.grassdoor.branchIoKey
			hideCartOnUpdate: true
			homeUrl: true

		# Don't show age confirmation since this was done on enter of site
		grassdoorCart.setAgeConfirmation true

		# Set the user's zip
		grassdoorCart.setDeliveryDetails postcode: zip

		# Update the cart count
		window.addEventListener 'cartUpdated', -> store.dispatch 'cart/fetchCount'

	# Make axios API client
	makeGrassdoorApiClient = (zip) -> $axios.create
		baseURL: $config.grassdoor.endpoint
		headers:
			x_api_key: $config.grassdoor.apiKey
			zip_code: zip

	# Hydrate as soon as we know the user's zip
	initializeAndHydrate = (zip) ->

		# Make the API client
		inject 'grassdoorApi', makeGrassdoorApiClient zip

		# Abort unless zip is supported by grassdoor
		unless await store.dispatch 'cart/determineIfZipSupported', zip
		then return store.commit 'cart/isHydrated' # This counts as hydrated

		# Do lookups that depended on zip
		await initializeSdk(zip).then -> Promise.all [
			store.dispatch 'cart/fetchCount'
			store.dispatch 'cart/fetchPurchaseableProducts'
		]
		store.commit 'cart/isHydrated'

	# Watch for the zip to be set
	store.watch ((state) -> state.customer.ageGateZip)
	, ((zip) -> initializeAndHydrate(zip) if !!zip)
	, immediate: true
